module.exports = __webpack_public_path__ + "media/promo/lum2021/images/lh_bg-f82f934fc4116c335dbcf414ceb3bedf.jpg";